const isSafari = navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome')
const isFirefox = navigator.userAgent.includes('Firefox')

export interface IClipboardData {
  html?: string
  plain_text?: string
}

export async function copyText(data: string | Promise<IClipboardData>, plainTextOnly = false) {
  if (typeof data === 'string') {
    return navigator.clipboard.writeText(data)
  } else if (data instanceof Promise) {
    if (isSafari) {
      // Safari requires promises that return Blobs
      return navigator.clipboard.write([
        new ClipboardItem({
          ['text/plain']: new Promise<Blob>(async (resolve) => {
            const { plain_text } = await data
            resolve(new Blob([plain_text], { type: 'text/plain' }))
          }),
          ...(plainTextOnly
            ? null
            : {
                ['text/html']: new Promise<Blob>(async (resolve) => {
                  const { html } = await data
                  resolve(new Blob([html], { type: 'text/html' }))
                }),
              }),
        }),
      ])
    } else {
      const { html, plain_text } = await data
      const clipboardItem = {
        ['text/plain']: new Blob([plain_text], { type: 'text/plain' }),
        ...(plainTextOnly
          ? null
          : {
              ['text/html']: new Blob([html], { type: 'text/html' }),
            }),
      }
      if (isFirefox) {
        const clipboard = await import('clipboard-polyfill')
        return clipboard.write([new clipboard.ClipboardItem(clipboardItem)])
      } else {
        return navigator.clipboard.write([new ClipboardItem(clipboardItem)])
      }
    }
  }
}
